import api from '@/api';
import staticData from '@/staticData';

export default {
	state: {
		sideMenu: [],
		showingSideMenu: false,
		showContent: true,
		showSpinner: false,
		showNoData: false
	},
	mutations: {
		SET_TEACHER_MENU (state, teacherMenu) {
			state.sideMenu[3].children = teacherMenu;
		},
		SET_SCHOOL_MENU (state, schoolMenu) {
			state.sideMenu[4].children[0].children = schoolMenu;
		},
		SET_VISIT_CLOSURE_MENU (state, visitClosureMenu) {
			state.sideMenu[4].children[1].children = visitClosureMenu;
		},
		SET_TRAINING_MENU (state, trainingMenu) {
			state.sideMenu[4].children[2].children = trainingMenu;
		},
		SET_DIAGNOSTIC_MENU (state, diagnosticMenu) {
			state.sideMenu[4].children[3].children = diagnosticMenu;
		},
		SET_ISSUE_MENU (state, issueMenu) {
			state.sideMenu[4].children[4].children = issueMenu;
		},
		SET_SIDE_MENU (state, sideMenu) {
			state.sideMenu = sideMenu;
		},
		TOGGLE_MENU (state) {
			state.showingSideMenu = !state.showingSideMenu;
		},
		SHOW_CONTENT (state) {
			state.showContent = true;
			state.showSpinner = false;
		},
		HIDE_CONTENT (state) {
			state.showContent = false;
			state.showSpinner = true;
		},
		SHOW_NO_DATA (state) {
			state.showNoData = true;
		},
		HIDE_NO_DATA (state) {
			state.showNoData = false;
		}
	},
	actions: {

		async setTeacherMenu (context, teacher) {
			let teacherMenu = [
				{
					title: 'Lista',
					isActive: false,
					route: '/coaching/teachers/list'
				},
				{
					title: `- ${teacher.fullName}`,
					isActive: true,
					extraClass: ['teacher'],
					children: [
						{
							title: 'Resumen',
							isActive: true,
							route: `/coaching/teachers/summary/${teacher.uuid}`
						},
						{
							title: 'Progreso',
							isActive: false,
							children: [
								{
									title: 'General',
									isActive: false,
									route: `/coaching/teachers/progress/${teacher.uuid}`
								},
								{
									title: 'Todas',
									isActive: false,
									route: `/coaching/teachers/progress/${teacher.uuid}/categories`
								},
								{
									title: 'Ambiente emocional',
									isActive: false,
									route: `/coaching/teachers/progress/${teacher.uuid}/categories/1`
								},
								{
									title: 'Proceso académico',
									isActive: false,
									route: `/coaching/teachers/progress/${teacher.uuid}/categories/2`
								},
								{
									title: 'Aprendizaje profundo',
									isActive: false,
									route: `/coaching/teachers/progress/${teacher.uuid}/categories/3`
								},
								{
									title: 'Aprendizaje experto',
									isActive: false,
									route: `/coaching/teachers/progress/${teacher.uuid}/categories/4`
								}
							]
						}
					]
				}
			];
			context.commit('SET_TEACHER_MENU', teacherMenu);
		},

		async setSchoolMenu (context, school) {
			let schoolMenu = [
				{
					title: `- ${school.name}`,
					isActive: true,
					extraClass: ['teacher'],
					children: [
						{
							title: 'Todo',
							isActive: false,
							route: `/coaching/admin/schools/${school.schoolId}/syntheses`
						},
						{
							title: 'Cierres de visita',
							isActive: false,
							route: `/coaching/admin/schools/${school.schoolId}/syntheses/1`,
							secondRoute: `/coaching/admin/schools/${school.schoolId}/visit-closure/`
						},
						{
							title: 'Formaciones',
							isActive: false,
							route: `/coaching/admin/schools/${school.schoolId}/syntheses/2`,
							secondRoute: `/coaching/admin/schools/${school.schoolId}/training/`
						},
						{
							title: 'Diagnóstico actual',
							isActive: false,
							route: `/coaching/admin/schools/${school.schoolId}/syntheses/3`,
							secondRoute: `/coaching/admin/schools/${school.schoolId}/diagnostic/`
						},
						{
							title: 'Incidencias',
							isActive: false,
							route: `/coaching/admin/schools/${school.schoolId}/issues`,
							secondRoute: `/coaching/admin/schools/${school.schoolId}/issue/`
						},
						{
							title: 'Indicadores',
							isActive: false,
							route: `/coaching/admin/schools/${school.schoolId}/syntheses/5`,
							secondRoute: `/coaching/admin/schools/${school.schoolId}/indicator/`
						},
						{
							title: 'Evaluaciones',
							isActive: false,
							route: `/coaching/admin/schools/${school.schoolId}/syntheses/6`,
							secondRoute: `/coaching/admin/schools/${school.schoolId}/evaluation/`
						}
					]
				}
			];
			context.commit('SET_SCHOOL_MENU', schoolMenu);
		},

		async resetSideMenu (context) {
			context.commit('SET_SIDE_MENU', staticData.sideMenu);
		},

		async toggleMenu (context) {
			context.commit('TOGGLE_MENU');
		},

		async activeMenu (context, currentRoute) {
			let sideMenu = staticData.sideMenu;
			if (currentRoute.includes('coaching')) {
				if (currentRoute.includes('school/')) {
					sideMenu.forEach((sideOption) => {sideOption.isActive = false;});
					sideMenu[0].isActive = true;
					if (currentRoute.includes('summary')) {
						sideMenu[0].children.forEach((sideOption) => {sideOption.isActive = false;});
						sideMenu[0].children[0].isActive = true;
					} else if (currentRoute.includes('progress')) {
						sideMenu[0].children.forEach((sideOption) => {sideOption.isActive = false;});
						sideMenu[0].children[1].isActive = true;
					}
				} else if (currentRoute.includes('academicLevels')) {
					sideMenu[1].isActive = true;
					if (currentRoute.includes('list') || currentRoute.includes('summary')) sideMenu[1].children[0].isActive = true;
					else if (currentRoute.includes('progress')) {
						sideMenu[1].children[1].isActive = true;
						if (currentRoute.includes('progress/3')) sideMenu[1].children[1].children[1].isActive = true;
						else if (currentRoute.includes('progress/1')) sideMenu[1].children[1].children[2].isActive = true;
						else if (currentRoute.includes('progress/2')) sideMenu[1].children[1].children[3].isActive = true;
					}
				} else if (currentRoute.includes('languages')) {
					sideMenu[2].isActive = true;
					if (currentRoute.includes('list') || currentRoute.includes('summary')) sideMenu[2].children[0].isActive = true;
					else if (currentRoute.includes('progress')) {
						sideMenu[2].children[1].isActive = true;
						if (currentRoute.includes('progress/es')) sideMenu[2].children[1].children[1].isActive = true;
						else if (currentRoute.includes('progress/en')) sideMenu[2].children[1].children[2].isActive = true;
					}
				} else if (currentRoute.includes('teachers')) {
					sideMenu[3].isActive = true;
					if (currentRoute.includes('list')) sideMenu[3].children[0].isActive = true;
				} else if (currentRoute.includes('/admin/')) {
					sideMenu[4].isActive = true;
					if (currentRoute.includes('schools')) sideMenu[4].children[0].isActive = true;
					/*if (currentRoute.includes('visit-closure')) sideMenu[4].children[1].isActive = true;
					if (currentRoute.includes('training')) sideMenu[4].children[2].isActive = true;
					if (currentRoute.includes('diagnostic')) sideMenu[4].children[3].isActive = true;
					if (currentRoute.includes('issue')) sideMenu[4].children[4].isActive = true;
					if (currentRoute.includes('evaluation')) sideMenu[4].children[5].isActive = true;*/
				}
			}
			context.commit('SET_SIDE_MENU', sideMenu);
		},

		showContent (context) {
			context.commit('SHOW_CONTENT');
		},

		hideContent (context) {
			context.commit('HIDE_CONTENT');
		},

		showNoData (context) {
			context.commit('SHOW_NO_DATA');
		},

		hideNoData (context) {
			context.commit('HIDE_NO_DATA');
		}
	}
};



// WEBPACK FOOTER //
// ./src/store/ui/index.js